import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isMobile
    ? _c(
        "div",
        {
          staticClass:
            "lpu-services-filter-online px-3 d-flex justify-space-between align-center",
          on: { click: _vm.handleClick },
        },
        [
          _c(VIcon, { attrs: { color: "primary" } }, [
            _vm._v("\n    ui-icon-calendar-date-and-clock\n  "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-body-2 text--text" }, [
            _vm._v("\n    Только услуги с онлайн-записью\n  "),
          ]),
          _vm._v(" "),
          _c(VSwitch, {
            attrs: { inset: "" },
            on: {
              click: function ($event) {
                $event.stopPropagation()
              },
              change: _vm.handleChange,
            },
            model: {
              value: _vm.isEnabledOnline,
              callback: function ($$v) {
                _vm.isEnabledOnline = $$v
              },
              expression: "isEnabledOnline",
            },
          }),
        ],
        1
      )
    : _c(VSwitch, {
        staticClass: "mt-0",
        attrs: { inset: "" },
        on: { change: _vm.handleChange },
        scopedSlots: _vm._u([
          {
            key: "label",
            fn: function () {
              return [
                _c("span", { staticClass: "text-body-2 text--text" }, [
                  _vm._v("\n      Только услуги с онлайн-записью\n    "),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.isEnabledOnline,
          callback: function ($$v) {
            _vm.isEnabledOnline = $$v
          },
          expression: "isEnabledOnline",
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }